import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LoginControl } from '../../providers/helpers/login';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  user : any = null;
  form : any = {
    senha: "",
    rsenha: ""
  };

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private msgHelper : MessageHelper, private loginCtrl: LoginControl,
    private service : ServiceProvider) {
      this.user = this.loginCtrl.getUser();
  }

  ionViewWillEnter()
  {
    this.user = this.loginCtrl.getUser();
  }

  /**
   * Atualiza os dados do usuário
   */
  updateDados()
  {
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.user,"/usuarios/save").then(result => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps",resultData.message);
      }
      this.msgHelper.showAlert("Sucesso!",resultData.message);
      this.loginCtrl.setUser(this.user);
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps",error.message);
    });
  }

  /**
   * Atualiza a senha do usuário
   * @returns VOID
   */
  updatePass()
  {
    if (this.form.senha == ""){
      return this.msgHelper.showToast("Você precisa informar a nova senha","bottom",1500);
    }
    if (this.form.rsenha == ""){
      return this.msgHelper.showToast("Você precisa confirmar a senha","bottom",1500);
    }
    this.form.token = this.user.token;
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();
    this.service.postData(this.form,"/usuarios/update-pass",false).then(result => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      return this.msgHelper.showAlert(resultData.result == 0 ? "Opps" : "Sucesso!",resultData.message);
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps",error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts